module.exports = __webpack_public_path__ + "static/media/shape1.06255572.webp";